"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";
import { logger } from "@/lib/logger";
import { Button } from "@/ui/shadcn/button";
import { YnsLink } from "@/ui/yns-link";

export default function ErrorPage({ error }: { error: Error & { digest?: string }; reset: () => void }) {
	useEffect(() => {
		logger.error(error);
		Sentry.captureException(error);
	}, [error]);

	return (
		<html lang="en">
			<body suppressHydrationWarning>
				<main className="mx-auto max-w-xl flex-auto text-center">
					<h1 className="mb-8 mt-8 text-4xl font-black">{error.name}</h1>
					<p>{error.message}</p>
					<p>{error.digest}</p>
					<pre>{error.stack}</pre>
					<Button variant="link" asChild>
						<YnsLink href="/">Go back</YnsLink>
					</Button>
				</main>
			</body>
		</html>
	);
}
